import React from 'react';
import LoginForm from '../../components/auth/LoginForm';

const LoginPage: React.FC = () => {
  return (
    <div className="flex min-h-screen bg-white">
      <div className="flex items-center justify-center flex-1 p-4">
        <LoginForm />
      </div>
      
      <div className="hidden lg:block w-1/2 bg-primary p-12 flex flex-col justify-center items-center">
        <div className="text-white text-center space-y-6">
          <h2 className="text-4xl font-bold">Master Chinese with HSK Learning App</h2>
          <p className="text-lg text-white/90">
            Comprehensive HSK test preparation and Chinese character learning
          </p>
          <ul className="mt-8 space-y-4">
            <li className="flex items-center space-x-3">
              <span className="text-2xl">📚</span>
              <span>HSK Level Assessment</span>
            </li>
            <li className="flex items-center space-x-3">
              <span className="text-2xl">🎯</span>
              <span>Interactive Character Training</span>
            </li>
            <li className="flex items-center space-x-3">
              <span className="text-2xl">🌍</span>
              <span>Multi-language Support</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
